import { useState } from "react";
import { stories, type Story } from "@/mocks/stories";
import { formatCount } from "@/utils/format";
import { catStyles } from "./catStyle";

function PosterCard({ story, index }: { story: Story; index: number }) {
  const [open, setOpen] = useState(false);
  return (
    <article className="group flex flex-col overflow-hidden rounded-3xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-300">
      <div className="relative flex items-center justify-between gap-3 bg-gradient-to-br from-accent-500 to-accent-600 px-6 py-5">
        <span className="text-5xl drop-shadow-sm">{story.reaction}</span>
        <div className="text-right">
          <p className="font-heading text-xs tracking-[0.25em] text-accent-950/70">社死现场</p>
          <p className="font-heading text-2xl text-white">
            N°{String(index).padStart(2, "0")}
          </p>
        </div>
      </div>
      <button onClick={() => setOpen((v) => !v)} className="flex flex-1 flex-col p-5 text-left">
        <span className="inline-flex w-fit items-center gap-1 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-bold text-accent-900">
          <i className="ri-emotion-laugh-line" /> 课堂同学社死现场
        </span>
        <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-900 transition-colors group-hover:text-accent-800">
          {story.title}
        </h3>
        <p className="mt-2 text-sm leading-relaxed text-foreground-600">
          {open ? story.content.join("") : story.excerpt}
        </p>
      </button>
      <div className="flex items-center justify-between border-t border-dashed border-background-200 px-5 py-3">
        <span className="text-xs text-foreground-400">
          <i className="ri-eye-line mr-1" />
          {formatCount(story.views)} 人在围观
        </span>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-500">
          <i className="ri-thumb-up-line" />
          {formatCount(story.likes)} 觉得好笑
        </span>
      </div>
    </article>
  );
}

export default function ClassroomSection() {
  const classroom = stories.filter((s) => s.category === "classroom");
  const st = catStyles.classroom;

  return (
    <section id="classroom" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${st.badge}`}>
            📖 课堂同学社死现场
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
            讲台上的名场面，一个比一个社死
          </h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            被点名卡壳、演讲忘词、老师叫错名……每一帧都想替你抠出三室一厅。
          </p>
        </div>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {classroom.map((s, i) => (
          <PosterCard key={s.id} story={s} index={i + 1} />
        ))}
        <a
          href="#submit"
          className="flex flex-col items-center justify-center gap-2 rounded-3xl border border-dashed border-accent-300 bg-accent-50/60 p-6 text-center transition-colors hover:bg-accent-100/70"
        >
          <span className="text-4xl">😳</span>
          <span className="font-heading text-lg text-accent-900">你有过课堂社死吗</span>
          <span className="text-xs text-accent-800">匿名讲出来，一起尴尬一起笑</span>
        </a>
      </div>
    </section>
  );
}